import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null,
    accessToken: null,
    accessTokenExpiresAt: null,
    isLoggedIn: false
  },
  mutations: {
    setSession(state, sessionResult) {
      let expiresIn = parseInt(sessionResult.expires_in)

      state.accessTokenExpiresAt = moment().add(expiresIn, 'second').toDate()
      state.currentUser = sessionResult.user
      state.accessToken = sessionResult.token
      state.isLoggedIn = true
    },
    clearSession(state) {
      state.currentUser = null
      state.accessToken = null
      state.accessTokenExpiresAt = null
      state.isLoggedIn = false
    }
  },
  actions: {

  },
  plugins: [ createPersistedState() ]
})
